// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"46":"dd829f02","896":"600dd30e","922":"d6045ad9","988":"7e45cd57"}[chunkId] + ".css";
};